module.exports = __webpack_public_path__ + "img/goldregen-2020-030.d0cd81eb.jpg";